import { FAQPage } from "schema-dts";
import { IQuestion } from "../../models/structured-data.model";
import createQuestion from "./create-question";

export default function createFAQPage(questions: IQuestion[],): FAQPage {
    return {
        '@type': 'FAQPage',
        mainEntity: questions.map(question => createQuestion(question))
    }
}